import { Button, DownloadIcon } from "melco-ui";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";
import { useDownloadAllUsersReport } from "../../hooks/reports/useDownloadAllUsersReport";
import { useConfirm } from "melco-shared-logic";
import { useDownloadDailySummaryReport } from "../../hooks/reports/useDownloadDailySummaryReport";

type UserReportDownloadButtonProps = {
  filename?: string;
  productCode?: string;
  dateRange?: any;
  userId?: string;
};

export const UserReportDownloadButton: React.FC<
  UserReportDownloadButtonProps
> = ({ filename, productCode, dateRange, userId }) => {
  const { t } = useTranslation();
  const [userReport, isLoading] = useDownloadDailySummaryReport(
    productCode ?? "",
    dateRange,
    userId ?? ""
  );

  const confirmDownload = useConfirm(
    async () => {
      const blob = await userReport();

      if (blob) {
        saveAs(blob, filename + ".csv");
      } else {
        console.log("Not a blob");
      }
    },
    {
      translationPrefix: "reports.actions.download",
    }
  );

  const downloadLogic = async () => {
    confirmDownload();
  };

  return (
    <Button
      key="report-download"
      icon={<DownloadIcon />}
      onClick={downloadLogic}
      loading={isLoading}
    >
      {t("reports.actions.download.button")}
    </Button>
  );
};
